"use client";

import styled, { keyframes } from "styled-components";

export const PrizesGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 24px;
  width: 842px;
  max-width: 100%;
  margin: 0 auto;
  @media (max-width: 1023px) {
    grid-template-columns: 1fr;
  }
`;

export const Prize = styled.div`
  border-radius: var(--rounding-radius-xxl, 32px);
  background: var(--fill-accent-primary, #9fe);
  padding: 48px 40px;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  img {
    width: 160px;
    height: 160px;
    object-fit: contain;
    object-position: center;
    display: block;
    margin-bottom: 30px;
  }

  @media (max-width: 1023px) {
    padding: 32px 16px;
    img {
      margin-bottom: 16px;
      width: 100px;
      height: 100px;
    }
  }
`;

export const TasksBlock = styled.div`
  border-radius: 56px;
  background: var(--background-accent-primary, #9fe);
  padding: var(--spacing-space-32, 32px);
  @media (max-width: 1023px) {
    margin: 0 -24px;
  }
`;

export const Task = styled.div`
  border-radius: var(--rounding-radius-xl, 24px);
  background: var(--background-primary, #fff);
  padding: var(--spacing-space-24, 24px);
  position: relative;
  overflow: hidden;
  .ticket {
    border-radius: 50%;
    border: 1px solid #FFF;
    background: var(--fill-accent-secondary, rgba(50, 250, 220, 0.16));
    backdrop-filter: blur(12px);
    img {
      width: 32px;
      height: 32px;
    }
  }

  &.friends {
    display: flex;
    align-items: center;
    gap: 24px;
    .btn {
      margin-top: 48px;
    }
    .img {
      width: 144px;
      height: 144px;
      object-fit: contain;
      object-position: center;
    }
  }
  .container {
    display: flex;
    flex: 1;
    flex-direction: column;
    height: 100%;
    justify-content: space-between;
  }
  .btn {
    margin-top: 40px;
    width: fit-content;
  }
  .phone,
  .phone-mobile,
  .icon {
    position: absolute;
    right: 0;
    bottom: 0;
    width: 62%;
    height: auto;
    object-fit: contain;
    object-position: right bottom;
  }
  .icon {
    width: 120px;
  }
  .phone-mobile {
    display: none;
  }
  .ticket-absolute {
    position: absolute;
    bottom: 16px;
    right: 104px;
  }
  @media (max-width: 1023px) {
    &.friends {
      flex-direction: column;
      align-items: flex-start;
      .btn {
        margin-top: 16px;
      }
    }
    .btn {
      margin-top: 0;
    }
    .phone {
      display: none;
    }
    .phone-mobile {
      display: block;
      width: 204px;
      height: 270px;
    }
    .ticket {
      width: 64px;
      height: 64px;
    }
  }
`;

export const TasksSubgrid = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 16px;
  margin-top: 16px;
  .column {
    display: grid;
    grid-template-rows: 1fr 1fr;
    gap: 16px;
  }
  @media (max-width: 1023px) {
    grid-template-columns: 1fr;
    .column .btn {
      margin-top: 40px;
    }
    .container > div {
      padding-right: 60px;
    }
  }
`;

export const ThumbnailsRow = styled.div`
  display: flex;
  & > div + div {
    margin: 0 -9px;
  }
`;

export const Banner = styled.div`
  border-radius: var(--rounding-radius-xxxl, 48px);
  background: var(--fill-positive-bg, rgba(165, 217, 139, 0.16));
  padding: var(--spacing-space-16, 16px) var(--spacing-space-32, 32px)
    var(--spacing-space-16, 16px) var(--spacing-space-16, 16px);
  display: flex;
  align-items: center;
  width: fit-content;
  margin: 0 auto;
  .icon {
    margin-inline-end: 16px;
    width: 64px;
    height: 64px;
  }
  .btn {
    margin-left: 16px;
  }
  @media (max-width: 1023px) {
    margin: 0 8px;
    .icon {
      margin: 0 auto;
    }
    .btn {
      margin-left: 0;
    }
    flex-direction: column;
    align-items: center;
    text-align: center;
    gap: 16px;
    padding: var(--spacing-space-32, 32px) var(--spacing-space-16, 16px);
  }
`;

export const LabelWrapper = styled.div`
  position: absolute;
  right: 24px;
  top: 26px;
  .md {
    font-size: 16px;
    font-weight: 600;
    gap: 4px;
    border-radius: var(--rounding-radius-m, 16px);
    padding: var(--spacing-space-4, 4px) var(--spacing-space-12, 12px)
      var(--spacing-space-4, 4px) var(--spacing-space-4, 4px);
    height: 32px;
    img {
      width: 24px;
      height: 24px;
    }
  }
`;
